import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input
} from "@angular/core"
import { CookieService } from "src/app/core/services/cookie.service"
import { ProfileService } from "src/app/cadastro/admin/services/profile.service"
import { AppService } from "src/app/core/services/app.service"
import { ActivatedRoute } from "@angular/router"
import { ToastrService } from "ngx-toastr"
import { environment } from "src/environments/environment"
import { TenantService } from "src/app/cadastro/admin/services/tenant.service"
import { UserService } from "src/app/cadastro/admin/services/user.service"
import { AccountService } from "src/app/cadastro/admin/services/account.service"
import { firstValueFrom } from "rxjs"
@Component({
  selector: "[app-header]",
  templateUrl: "./app-header.component.html",
  styleUrls: ["./app-header.component.css"],
})
export class AppHeaderComponent implements OnInit {
  user: string
  tenantId: string
  isDropdownVisible: Boolean = false
  tutorialUrl: string
  currentRole: string
  urlLexUiWeb: string

  @Input() toggleSideMenu: Function

  @ViewChild("hubNavMenuDropdownButton") hubNavMenuDropdownButton: ElementRef
  @ViewChild("hubNavMenuDropdownList") hubNavMenuDropdownList: ElementRef

  constructor(
    private profileService: ProfileService,
    public tenantService: TenantService,
    private appService: AppService,
    private currentRoute: ActivatedRoute,
    private cookieService: CookieService,
    private userService: UserService,
    private accountService: AccountService,
    private toastr: ToastrService
  ) {}

  async ngOnInit(): Promise<void> {
    this.getCurrentUser()
    this.getUserHelp()
    this.urlLexUiWeb = environment.endpointLexUiWeb.url
  }

  getCurrentUser() {
    this.currentRoute.queryParams.subscribe((params) => {
      if (params.accessToken) {
        this.userService.getUserInfo().subscribe(({ name, role }) => {
          this.user = name
          this.currentRole = role
        })
      } else if (
        this.appService.currentUser &&
        this.appService.currentUser.name
      ) {
        this.user = this.appService.currentUser.name
        this.currentRole = this.appService.currentUser.role
      }
    })
  }

  logout() {
    this.cookieService.deleteCookie("auth")
    this.cookieService.deleteCookie("userId")
    this.cookieService.deleteCookie("role")
    this.cookieService.deleteCookie("isAdminConexia")
    this.accountService.clearUserInformationsCache()
    this.toastr.warning("Aguarde...")
    setTimeout(() => {
      window.location.href = environment.endpointLexUiWeb.url
    }, 1000)
  }

  menuDropdownButtonOnClick() {
    this.isDropdownVisible = !this.isDropdownVisible
  }

  mouseEvent(e: any) {
    if (
      e.target.className !=
        this.hubNavMenuDropdownButton.nativeElement.className &&
      e.target.parentNode.className !=
        this.hubNavMenuDropdownButton.nativeElement.className &&
      e.target.className !=
        this.hubNavMenuDropdownList.nativeElement.className &&
      e.target.parentNode.className !=
        this.hubNavMenuDropdownList.nativeElement.className
    ) {
      this.isDropdownVisible = false
    }
  }

  getUserHelp() {
    this.profileService.getUserHelp().subscribe((data) => {
      if (data) {
        this.tutorialUrl = data.url
      }
    })
  }

  get isAdminConexia() {
    return this.currentRole === "conexia"
  }
}
